
import EventItem from '@/components/events/event-item';

export default class SmallEventItem extends EventItem {}
